import { useState, useRef, useMemo } from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react/dist/iconify.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ImageCarousel = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  const safeImages = images || [];
  const hasImages = safeImages.length > 0;

  const settings = useMemo(() => ({
    dots: true,
    arrows: safeImages.length > 1,
    infinite: safeImages.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    afterChange: (current) => setCurrentSlide(current),
    appendDots: (dots) => (
      <div style={{ bottom: '10px', position: 'absolute', width: '100%' }}>
        <ul style={{ margin: 0, padding: 0, display: 'flex', justifyContent: 'center', gap: '8px' }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        className="custom-dot"
        style={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: '#ccc',
          transition: 'background-color 0.3s ease'
        }}
      />
    ),
  }), [safeImages.length]);

  if (!hasImages) {
    return (
      <div className="card p-3 text-center text-muted">
        <Icon icon="mdi:image-off" width="30" height="30" />
        <p className="mb-0 mt-2 small">No images available</p>
      </div>
    );
  }

  const progress = ((currentSlide + 1) / safeImages.length) * 100;

  return (
    <div className="card p-0 overflow-hidden position-relative radius-12">
      <style>
        {`
          .slick-active .custom-dot {
            background-color: #22c55e !important;
          }
        `}
      </style>
      <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0">
        <h6 className="text-lg mb-0">Plantation Images</h6>
      </div>
      <div className="card-body p-0 position-relative">
        <Slider {...settings} ref={sliderRef} key={safeImages.length}>
          {safeImages.map((imageUrl, index) => (
            <div
              key={index}
              className="gradient-overlay bottom-0 start-0 h-100 position-relative"
            >
              <img
                src={imageUrl}
                alt={`Plantation ${index + 1} of ${safeImages.length}`}
                className="w-100 h-100 object-fit-cover"
                style={{ maxHeight: '750px', minHeight: '300px' }}
                onError={(e) => {
                  e.target.src =
                    'https://via.placeholder.com/600x400?text=Image+Not+Found';
                }}
              />
              <div className="position-absolute start-50 translate-middle-x bottom-0 pb-24 z-1 text-center w-100 max-w-440-px">
                <p className="card-text text-white mx-auto text-sm">
                  {index + 1} of {safeImages.length}
                </p>
              </div>
            </div>
          ))}
        </Slider>
        <div
          className="slider-progress"
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            height: '4px',
            width: '100%',
            backgroundColor: '#eee',
          }}
        >
          <span
            className="active"
            style={{
              display: 'block',
              height: '100%',
              backgroundColor: '#22c55e',
              width: `${progress}%`,
              transition: 'width 0.5s ease',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;